import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { ProjectRestControllerService } from 'src/app/services/api-client/services';
import { Observable } from 'rxjs';

@Injectable()
export class ProjectDataResolver implements Resolve<any>  {

  constructor(
    private projService: ProjectRestControllerService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot
  ): Observable<any> {
    return this.projService.getProjects();
  }
}
